angular
    .module('app')
    .directive('dropdownYear', DropdownYear);

DropdownYear.$inject = [];
function DropdownYear() {
    function getYears(offset, range){
        var currentYear = new Date().getFullYear() - offset;
        var years = [];
        for (var i = currentYear; i > currentYear - range - 1; i--) {
            years.push(i);
        }
        return years;
    }
    return {
        restrict: 'A',
        scope: {
            ngModel: '=',
        },
        link: function(scope, element, attrs){
            scope.years = getYears(+attrs.offset, +attrs.range);
        },
        template:   '<label class="small" translate>Year</label>' + 
                    '<select class="form-control input-sm" ng-model="ngModel">' + 
                    '<option value="" translate>Any</option>' + 
                    '<option ng-repeat="y in years" value="{{y}}">{{y}}</option>' +
                    '</select>'
    };
}
